/**
 * EU-711 — "esta falha é ausência de conexão?"
 *
 * O transporte do `candidate-api-sdk` marca queda de conexão e abort de timeout
 * com `status: 0` (é o único caso em que `fetch` REJEITA em vez de responder).
 * Qualquer outro status significa que o servidor respondeu — logo, há conexão.
 *
 * A distinção é load-bearing: um `5xx` com internet ativa tem que levar à tela
 * de erro de servidor, nunca a "Você está sem internet" (OFF-009). Mandar o
 * candidato conferir o wi-fi por um problema nosso é pior que não dizer nada.
 *
 * Sem dependências de propósito — usada pelo store (que não pode conhecer a UI)
 * e pela política de toast (que conhece).
 */
export function isNetworkFailure(error: unknown): boolean {
  return (error as { status?: number } | null | undefined)?.status === 0;
}
